import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import uiStyles from './SortedSelect.module.scss';

class UnsortedSelect extends React.Component {
  render() {
    const {
      isCreatable = false,
      styles,
      menuPortalTarget,
      className,
      variant = undefined,
      ...componentProps
    } = this.props;

    const styleToApply = (() => {
      if (variant && uiStyles[variant]) {
        return uiStyles[variant];
      }
      return className;
    })();

    const selectProps = {
      menuPortalTarget: menuPortalTarget || undefined,
      styles: {
        ...styles,
        menuPortal: (base) => ({
          ...base,
          ...styles?.menuPortal?.(base),
          zIndex: 9999,
        }),
        menu: (base) => ({
          ...base,
          ...(styles?.menu ? styles.menu(base) : {}),
          zIndex: 9999,
        }),
      },
      className: styleToApply,
      ...componentProps,
    };

    if (isCreatable) {
      return (
        <CreatableSelect
          menuPlacement="auto"
          createOptionPosition="first"
          formatCreateLabel={(s) => `Use "${s}"`}
          {...selectProps}
          data-testid={componentProps['data-testid']}
        />
      );
    }

    return <Select {...selectProps} />;
  }
}

export default UnsortedSelect;
